var map = {
	"./default/assets/SnappyIcon.svg": 63812,
	"./default/assets/font.css": 13411,
	"./default/assets/tailwind.css": 28924,
	"./demo/assets/font.css": 60591,
	"./demo/assets/images/color.png": 37398,
	"./demo/assets/images/hue.png": 92609,
	"./demo/assets/images/snappy_data.svg": 86623,
	"./demo/assets/images/snappy_elements.svg": 64076,
	"./demo/assets/images/snappy_flows.svg": 5646,
	"./demo/assets/logo.svg": 79321,
	"./driveplus/assets/font.css": 86064,
	"./driveplus/assets/images/color.png": 49269,
	"./driveplus/assets/images/hue.png": 50690,
	"./driveplus/assets/logo.svg": 97324,
	"./flow/assets/font.css": 14106,
	"./flow/assets/images/color.png": 27739,
	"./flow/assets/images/hue.png": 50576,
	"./flow/assets/images/snappy_data.svg": 73882,
	"./flow/assets/images/snappy_elements.svg": 79917,
	"./flow/assets/images/snappy_flows.svg": 93017,
	"./flow/assets/logo.svg": 17952,
	"./flyingtiger/assets/font.css": 9298,
	"./flyingtiger/assets/images/color.png": 58643,
	"./flyingtiger/assets/images/hue.png": 39336,
	"./flyingtiger/assets/images/login1.svg": 16432,
	"./flyingtiger/assets/images/login2.svg": 73475,
	"./flyingtiger/assets/images/login3.svg": 58834,
	"./flyingtiger/assets/images/login4.svg": 92765,
	"./flyingtiger/assets/images/snappy_data.svg": 82604,
	"./flyingtiger/assets/images/snappy_elements.svg": 92391,
	"./flyingtiger/assets/images/snappy_flows.svg": 18839,
	"./flyingtiger/assets/images/snappy_onyx_small.png": 80386,
	"./flyingtiger/assets/logo.svg": 77990,
	"./gartenkultur/assets/font.css": 75536,
	"./gartenkultur/assets/images/color.png": 44037,
	"./gartenkultur/assets/images/hue.png": 97586,
	"./gartenkultur/assets/images/login1.svg": 88232,
	"./gartenkultur/assets/images/login2.svg": 38971,
	"./gartenkultur/assets/images/login3.svg": 78602,
	"./gartenkultur/assets/images/login4.svg": 85461,
	"./gartenkultur/assets/images/snappy_data.svg": 49892,
	"./gartenkultur/assets/images/snappy_elements.svg": 879,
	"./gartenkultur/assets/images/snappy_flows.svg": 68959,
	"./gartenkultur/assets/images/snappy_onyx_small.png": 51976,
	"./gartenkultur/assets/logo.svg": 66670,
	"./gerstl/assets/font.css": 73359,
	"./gerstl/assets/images/color.png": 2822,
	"./gerstl/assets/images/hue.png": 58321,
	"./gerstl/assets/logo.svg": 53873,
	"./impactsolutions/assets/font.css": 8774,
	"./impactsolutions/assets/images/color.png": 13351,
	"./impactsolutions/assets/images/hue.png": 47076,
	"./impactsolutions/assets/images/snappy_data.svg": 9912,
	"./impactsolutions/assets/images/snappy_elements.svg": 87115,
	"./impactsolutions/assets/images/snappy_flows.svg": 60331,
	"./impactsolutions/assets/logo.svg": 1218,
	"./itmc/assets/font.css": 50273,
	"./itmc/assets/images/color.png": 18420,
	"./itmc/assets/images/hue.png": 82599,
	"./itmc/assets/logo.svg": 59911,
	"./krediflow/assets/SnappyIcon.svg": 1474,
	"./krediflow/assets/font.css": 46313,
	"./krediflow/assets/tailwind.css": 33830,
	"./llm/assets/font.css": 14653,
	"./llm/assets/images/color.png": 60808,
	"./llm/assets/images/hue.png": 91811,
	"./llm/assets/images/snappy_data.svg": 40935,
	"./llm/assets/images/snappy_elements.svg": 43076,
	"./llm/assets/images/snappy_flows.svg": 63014,
	"./llm/assets/llm_diagram.png": 32315,
	"./llm/assets/logo.svg": 51473,
	"./mb/assets/font.css": 22871,
	"./mb/assets/images/color.png": 53606,
	"./mb/assets/images/hue.png": 56561,
	"./mb/assets/images/login1.svg": 49809,
	"./mb/assets/images/login2.svg": 85762,
	"./mb/assets/images/login3.svg": 99987,
	"./mb/assets/images/login4.svg": 43244,
	"./mb/assets/images/snappy_data.svg": 12407,
	"./mb/assets/images/snappy_elements.svg": 49460,
	"./mb/assets/images/snappy_flows.svg": 7286,
	"./mb/assets/images/snappy_jobs.svg": 78031,
	"./mb/assets/images/snappy_onyx_small.png": 99455,
	"./mb/assets/logo.svg": 31297,
	"./motolino/assets/SnappyIcon.svg": 21024,
	"./motolino/assets/font.css": 22305,
	"./motolino/assets/images/color.png": 91724,
	"./motolino/assets/images/hue.png": 99199,
	"./motolino/assets/images/nx.png": 73303,
	"./motolino/assets/images/ny.png": 30286,
	"./motolino/assets/images/nz.png": 2085,
	"./motolino/assets/images/px.png": 16909,
	"./motolino/assets/images/py.png": 63012,
	"./motolino/assets/images/pz.png": 99871,
	"./motolino/assets/logo.svg": 90091,
	"./motolino/assets/tailwind.css": 72190,
	"./neuraxis/assets/font.css": 61407,
	"./neuraxis/assets/images/color.png": 72398,
	"./neuraxis/assets/images/hue.png": 27065,
	"./neuraxis/assets/logo.svg": 41397,
	"./partner/assets/font.css": 68738,
	"./partner/assets/images/color.png": 35315,
	"./partner/assets/images/hue.png": 11656,
	"./partner/assets/images/snappy_data.svg": 93320,
	"./partner/assets/images/snappy_elements.svg": 54971,
	"./partner/assets/images/snappy_flows.svg": 75835,
	"./partner/assets/logo.svg": 78162,
	"./poc/assets/font.css": 87358,
	"./poc/assets/images/color.png": 60855,
	"./poc/assets/images/hue.png": 85748,
	"./poc/assets/images/snappy_data.svg": 39172,
	"./poc/assets/images/snappy_elements.svg": 64175,
	"./poc/assets/images/snappy_flows.svg": 66399,
	"./poc/assets/images/snappy_onyx_small.png": 55230,
	"./poc/assets/logo.svg": 91374,
	"./prosperita/assets/font.css": 6285,
	"./prosperita/assets/images/color.png": 26544,
	"./prosperita/assets/images/hue.png": 86699,
	"./prosperita/assets/images/snappy_data.svg": 21365,
	"./prosperita/assets/images/snappy_elements.svg": 35154,
	"./prosperita/assets/images/snappy_flows.svg": 77528,
	"./prosperita/assets/logo.svg": 55523,
	"./providebit/assets/font.css": 97010,
	"./providebit/assets/images/color.png": 50651,
	"./providebit/assets/images/hue.png": 83856,
	"./providebit/assets/logo.svg": 27188,
	"./senler/assets/font.css": 20433,
	"./senler/assets/images/color.png": 43412,
	"./senler/assets/images/hue.png": 85191,
	"./senler/assets/images/snappy_data.svg": 67481,
	"./senler/assets/images/snappy_elements.svg": 78462,
	"./senler/assets/images/snappy_flows.svg": 87252,
	"./senler/assets/logo.svg": 44343,
	"./snappy/assets/font.css": 54815,
	"./snappy/assets/images/color.png": 18094,
	"./snappy/assets/images/hue.png": 99385,
	"./snappy/assets/images/snappy_bexio.svg": 90584,
	"./snappy/assets/images/snappy_data.svg": 53755,
	"./snappy/assets/images/snappy_ecommerce.svg": 269,
	"./snappy/assets/images/snappy_elements.svg": 25152,
	"./snappy/assets/images/snappy_fintech.svg": 37526,
	"./snappy/assets/images/snappy_flows.svg": 44706,
	"./snappy/assets/images/snappy_invoice_automation.svg": 80842,
	"./snappy/assets/images/snappy_llm.svg": 65172,
	"./snappy/assets/images/snappy_pages.svg": 20561,
	"./snappy/assets/logo.svg": 26901,
	"./snpy/assets/font.css": 15796,
	"./snpy/assets/images/color.png": 32665,
	"./snpy/assets/images/hue.png": 55582,
	"./snpy/assets/images/snappy_data.svg": 40784,
	"./snpy/assets/images/snappy_elements.svg": 31251,
	"./snpy/assets/images/snappy_flows.svg": 65619,
	"./snpy/assets/logo.svg": 39562,
	"./sprachtechnik/assets/font.css": 6147,
	"./sprachtechnik/assets/images/color.png": 52770,
	"./sprachtechnik/assets/images/hue.png": 73349,
	"./sprachtechnik/assets/images/login1.svg": 75803,
	"./sprachtechnik/assets/images/login2.svg": 94440,
	"./sprachtechnik/assets/images/login3.svg": 76185,
	"./sprachtechnik/assets/images/login4.svg": 92502,
	"./sprachtechnik/assets/images/snappy_onyx_small.png": 48979,
	"./sprachtechnik/assets/logo.svg": 55563,
	"./sprachtechnik/assets/record_end.mp3": 67738,
	"./sprachtechnik/assets/record_start.mp3": 69957,
	"./sprachtechnik/assets/swisswool_logo.png": 13736,
	"./sula/assets/font.css": 43151,
	"./sula/assets/images/color.png": 10918,
	"./sula/assets/images/hue.png": 83825,
	"./sula/assets/logo.svg": 69253,
	"./swisswool/assets/font.css": 48430,
	"./swisswool/assets/images/color.png": 80615,
	"./swisswool/assets/images/hue.png": 38020,
	"./swisswool/assets/images/snappy_data.svg": 51036,
	"./swisswool/assets/images/snappy_elements.svg": 39895,
	"./swisswool/assets/images/snappy_flows.svg": 17479,
	"./swisswool/assets/logo.svg": 61174,
	"./uniska/assets/font.css": 25267,
	"./uniska/assets/images/color.png": 77490,
	"./uniska/assets/images/hue.png": 41077,
	"./uniska/assets/images/snappy_data.svg": 27591,
	"./uniska/assets/images/snappy_elements.svg": 22724,
	"./uniska/assets/images/snappy_flows.svg": 28614,
	"./uniska/assets/logo.svg": 44113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71255;